import { useState } from 'react';
import { MessageContainerKey, MessageManager, MessageOptions } from '../message';
import { NotificationComponentProps } from './Notification';

interface NotificationType {
  show: (props: MessageOptions<NotificationComponentProps>) => void;
  destroy: (id: string, key?: MessageContainerKey) => void;
}

export function useNotification() {
  const [notification] = useState<NotificationType>(() => {
    if (typeof window === 'undefined') {
      return { show: () => {}, destroy: () => {} };
    }
    const notification_instance = MessageManager.getInstance(
      'notification',
    ) as MessageManager<NotificationComponentProps>;
    notification_instance.setInstance = {
      default_max_count: 3,
      default_offset: 16,
      default_position: 'top-right',
    };
    return notification_instance;
  });

  return notification;
}
